import type { FC } from 'react';

import Search from '@crehana/compass.icons.outline/Search';
import { InputField } from '@crehana/compass.ui';
import { useTranslation } from '@crehana/i18n';
import PrevSearch from '@crehana/icons/Search';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors, TextField } from '@crehana/ui';
import { clsx } from 'clsx';

import { SelectedRecordsActions } from './components';
import type { TableContainerProps } from './types';

const { baseLighter } = colors;

const TableContainer: FC<React.PropsWithChildren<TableContainerProps>> = ({
  actions,
  children,
  className,
  hideCounter,
  isDark,
  isOnlyWrapper,
  smallPadding,
  tailwindMode,
  textField,
  title,
  totalCount,
  hiddePaddingTop,
  ...restProps
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        'tw-w-full tw-rounded-1 dark:tw-bg-elevation-dark-01 tw-bg-neutral-light-100 tw-inline-block',
        className,
      )}
    >
      {!isOnlyWrapper && (
        <div
          className={clsx(
            hiddePaddingTop
              ? 'tw-px-0 tw-pt-0'
              : [smallPadding ? 'tw-pt-1.2 tw-px-1.2' : 'tw-pt-2.4 tw-px-2.4'],
            'tw-gap-1.6 tw-flex tw-flex-wrap tw-justify-between',
          )}
        >
          <div className="tw-flex tw-flex-wrap tw-items-center">
            {Boolean(title) && (
              <div className="tw-font-subtitle5 tw-mr-0.8 dark:tw-text-neutral-dark-500">
                {title}
              </div>
            )}
            {!hideCounter && (
              <div
                className={clsx(
                  'dark:tw-bg-neutral-dark-700 dark:tw-text-neutral-dark-500 tw-bg-neutral-light-400 tw-font-link1 py-2 tw-px-0.8 tw-rounded-0.4 tw-mr-2',
                )}
              >
                {totalCount}
              </div>
            )}
            {textField &&
              (tailwindMode ? (
                <InputField
                  hideLabel
                  leadingIcon={Search}
                  placeholder={textField.hint || t('DEFAULT_SEARCH_HINT')}
                  {...textField}
                  label={textField.hint || t('DEFAULT_SEARCH_HINT')}
                />
              ) : (
                <TextField
                  chat
                  darkMode={isDark}
                  startAdornment={<PrevSearch color={baseLighter} size={24} />}
                  hint={textField.hint || t('DEFAULT_SEARCH_HINT')}
                  {...textField}
                />
              ))}
            <SelectedRecordsActions {...restProps} />
          </div>
          {actions}
        </div>
      )}
      {children}
    </div>
  );
};

export default TableContainer;
